import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { ExpenseTypeActions } from '../actions/expense-type.actions';
import { ExpenseType } from '../models/expense-type.model';
import { ExpenseTypeService } from 'src/app/services/expense-type.service';
import { StorageService } from 'src/app/services/storage.service';

export class ExpenseTypeStateModel {
    is_refreshing: boolean
    expense_type: ExpenseType[]
}

@State<ExpenseTypeStateModel>({
    name: 'expense_type',
    defaults: {
        is_refreshing: true,
        expense_type: []
    }
})
@Injectable()
export class ExpenseTypeState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private expenseTypeService: ExpenseTypeService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<ExpenseTypeStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {                      
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {             
        if (this.storageService.is_initialized) {
            const state_model: ExpenseTypeStateModel = change.currentValue      
            this.storageService.set('expense_types', JSON.stringify(state_model))    
        }  
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('expense_types');        
        if (json) {
            const state_model: ExpenseTypeStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new ExpenseTypeActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new ExpenseTypeActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.expenseTypeService.getAll()    
        if (objs != null) {
          const many = ExpenseType.buildMany(objs)                  
          this.store.dispatch(new ExpenseTypeActions.Set(many))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: ExpenseTypeStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: ExpenseTypeStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: ExpenseTypeStateModel) {
        return state.expense_type
    }

    @Action(ExpenseTypeActions.Refresh)
    async refresh({patchState}: StateContext<ExpenseTypeStateModel>, {  }:ExpenseTypeActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(ExpenseTypeActions.Init)
    init({setState, getState}: StateContext<ExpenseTypeStateModel>, { payload }:ExpenseTypeActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new ExpenseTypeActions.Refresh())
    }
    
    @Action(ExpenseTypeActions.Set)
    set({setState}: StateContext<ExpenseTypeStateModel>, { payload }:ExpenseTypeActions.Set) {             
        setState({   
            is_refreshing: false,         
            expense_type: payload
        })
    }
}
